var render = function render(){var _vm=this,_c=_vm._self._c;return (this.$root.fullScreenLoading)?_c('div',{staticClass:"admin_loader"},[_c('div',{staticClass:"__visibility_block"}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"__loader_wrap"},[_c('div',{staticClass:"__loader_image"},[_c('span')]),_c('div',{staticClass:"__loader_content"},[_vm._v("Уншиж байна ...")])])
}]

export { render, staticRenderFns }